import {
  Pagination,
  Table,
  Button,
  Card,
  FormField,
  FormGrid,
  FormRow,
} from "@endya-conformite/ui-kit";
import CheckCircleFill from "@endya-conformite/ui-kit/src/assets/icons/check-circle-fill.svg?react";
import ChevronDown from "@endya-conformite/ui-kit/src/assets/icons/chevron-down.svg?react";
import ChevronUp from "@endya-conformite/ui-kit/src/assets/icons/chevron-up.svg?react";
import Pencil from "@endya-conformite/ui-kit/src/assets/icons/pencil.svg?react";
import XCircleFill from "@endya-conformite/ui-kit/src/assets/icons/x-circle-fill.svg?react";
import { AssujettiDataItemError } from "@src/assujettis/AssujettiData";
import { useFilterPagination } from "@src/components/Filter/useFilterPagination";
import { useState } from "react";
import styles from "./AssujettiImportErrors.module.scss";

type AssujettiImportErrorsProps = {
  errors: AssujettiDataItemError[];
  onUpdate: (entreprise: AssujettiDataItemError) => void;
};

export const ASSUJETTIS_PAGE_SIZE = 25;

export function AssujettiImportErrors({
  onUpdate,
  errors,
}: AssujettiImportErrorsProps) {
  const [isOpen, setIsOpen] = useState(true);
  const { content, page, setPage, pageSize } = useFilterPagination({
    content: errors,
    pagination: { pageSize: ASSUJETTIS_PAGE_SIZE },
  });

  return (
    <Card>
      <FormGrid disableHorizontalGutter>
        <FormRow className={styles.cardHeader}>
          <FormField>
            <h2>
              <span className={styles.countErrors}>{errors.length} </span>
              ligne
              {errors.length > 1 ? "s" : ""} en erreur
            </h2>
          </FormField>
          <FormField className={styles.collapseButton}>
            <Button
              variant="text"
              onClick={() => setIsOpen((prev) => !prev)}
              icon={isOpen ? <ChevronUp /> : <ChevronDown />}
            />
          </FormField>
        </FormRow>
        {isOpen && (
          <>
            <FormRow>
              <FormField>
                <Table
                  className={styles.tableWithoutShadow}
                  data={content}
                  columns={[
                    {
                      key: "index",
                      title: "Ligne",
                      size: 1,
                      render: ({ index }) => <p>{index}</p>,
                    },

                    {
                      key: "name",
                      title: "Nom prénom",
                      size: 2,
                      render: (importInError) => (
                        <p className={styles.raisonSociale}>
                          {importInError.errors.length > 0 ? (
                            <XCircleFill className={styles.error} />
                          ) : (
                            <CheckCircleFill className={styles.success} />
                          )}{" "}
                          {importInError.data?.assujetti?.name}{" "}
                          {importInError.data?.assujetti?.surname}
                        </p>
                      ),
                    },
                    {
                      key: "siren",
                      title: "SIREN",
                      size: 2,
                      render: (importInError) => (
                        <p>{importInError.data?.assujetti?.sirenCompany}</p>
                      ),
                    },
                    {
                      key: "error",
                      title: "Erreur",
                      size: 3,
                      render: (importInError) => (
                        <span>
                          {importInError.errors.map((error) => (
                            <p key={error.key}>{error.description}</p>
                          ))}
                        </span>
                      ),
                    },
                    {
                      key: "actions",
                      size: "auto",
                      render: (importInError) =>
                        importInError.errors.length > 0 ? (
                          <Button
                            icon={<Pencil />}
                            variant="text"
                            onClick={() => onUpdate(importInError)}
                          >
                            Corriger
                          </Button>
                        ) : (
                          <div />
                        ),
                    },
                  ]}
                />
              </FormField>
            </FormRow>
            <FormRow>
              <FormField className={styles.paginationContainer}>
                <Pagination
                  page={page}
                  onChange={setPage}
                  pageSize={pageSize}
                  total={errors.length}
                />
              </FormField>
            </FormRow>
          </>
        )}
      </FormGrid>
    </Card>
  );
}
